import { useState, useEffect, useRef } from 'react';


function useFetchData(fetchFunction, ...args) {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // `args` is a new array on every render, so it can never be a dependency
    // directly. Key the effect on a stable serialization of it instead, and
    // read the current values through a ref so the effect body stays honest
    // about what it depends on.
    const argsKey = JSON.stringify(args);
    const argsRef = useRef(args);
    argsRef.current = args;

    useEffect(() => {
        let cancelled = false;

        const fetchData = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const result = await fetchFunction(...argsRef.current);
                if (!cancelled) setData(result);
            } catch (error) {
                if (!cancelled) setError(error);
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        };

        fetchData();

        return () => {
            cancelled = true;
        };
    }, [fetchFunction, argsKey]);

    return { data, isLoading, error };
}
export default useFetchData;
